export default "__VITE_ASSET__6f421b0a__"